import styled, { keyframes } from "styled-components"
import { colors } from "./color"

export const WatchMovieDiv = styled.div`
    max-width: 65%;
    margin: auto;
    margin-top: 68px;
    padding: 15px;
    padding-bottom: 100px;
    background-color: ${colors.secondary};

    @media screen and (max-width: 768px) {
        max-width: 100%;
        //margin: 0 20px;
        padding: 10px 0 130px 0;
    }
    @media screen and (min-width: 768px) and (max-width: 1024px) {
        max-width: 90%;
        padding-top: 10px;
    }

    > .watchSerieH1 {
        &:hover {
            color: ${colors.primary};
        }
    }

    > h1 {
        color: white;
        font-size: 1.25cm;
        display: flex;
        align-items: center;
        gap: 15px;
        margin: 20px 0;

        @media screen and (max-width: 768px) {
            font-size: 0.9cm;
            gap: 10px;
            align-items: start;
            margin: 20px 10px;
        }
        @media screen and (min-width: 768px) and (max-width: 1024px) {
            font-size: 1.15cm;
        }

        > span {
            width: 7px;
            height: 35px;
            border-radius: 8px;
            margin-top: 7px;
            background-color: ${colors.primary};

            @media screen and (max-width: 768px) {
                height: 28px;
                margin-top: 12px;
            }
        }
    }
`
export const BannerAdDiv = styled.div`
    width: 100%;
    height: 24vh;
    font-size: 1.2cm;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${colors.backgrond};
    border-radius: 8px;

    @media screen and (max-width: 768px) {
        max-width: 100%;
        height: 22vh;
        font-size: 1cm;
        //margin: 0 10px;
    }
`
// Animation fondu
const fadeIn = keyframes`
  from { background: rgba(0,0,0,0); }
  to { background: rgba(0,0,0,1); }
`

export const FullscreenWrapper = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 9999;
    animation: ${fadeIn} 0.3s ease forwards;
    background: black;
    display: flex;
    justify-content: center;
    align-items: center;
`

export const StyledIFrame = styled.iframe.attrs({
    allow: "fullscreen; autoplay; encrypted-media; picture-in-picture",
    allowFullScreen: true,
})`
    width: 100%;
    height: 400px;
    border-radius: 10px;
    margin: 0;
    background-color: ${colors.backgrond};
    transition: all 0.3s ease;
    @media screen and (max-width: 744px) {
        height: 280px;
        max-width: 100%;
        //margin: 0 10px;
    }

    &.fullscreen {
        width: 100vw;
        height: 100vh;
    }
`
export const SynopsisDiv = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin: 20px 0;
    @media screen and (max-width: 768px) {
        margin: 20px 10px;
    }

    > h2 {
        font-size: 1.8em;
        display: flex;
        //align-items: center;
        gap: 6px;
        margin: 0;
        @media screen and (max-width: 768px) {
            font-size: 1.7em;
        }

        > span {
            width: 4.5px;
            height: 22px;
            align-self: center;
            border-radius: 5px;
            background-color: ${colors.primary};
            margin-top: 4px;
        }
    }

    > p {
        font-size: 1.15em;
        line-height: 1.5em;
        text-align: justify;
        margin-right: 80px;
        margin: 0;
        @media screen and (max-width: 768px) {
            font-size: 1.1em;
            margin-right: 0;
        }
    }
`
export const PlayMovieDiv = styled.div`
    position: relative;
    height: 265px;
    max-width: 70vh;
    margin: auto;
    background-color: ${colors.backgrond};
    @media screen and (min-width: 768px) {
        max-width: 100%;
        height: 400px;
        border-radius: 10px;
        margin: auto;
    }

    > img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        border-radius: 10px;
        @media screen and (min-width: 768px) {
            max-height: 400px;
        }
    }

    > button {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 1em;
        font-weight: 600;
        color: rgba(255, 255, 255, 0.8);
        background-color: ${colors.primary};
        display: flex;
        align-items: center;
        gap: 15px;
        padding: 13px 35px;
        border-radius: 6px;
        border: none;
        cursor: pointer;
        @media screen and (min-width: 768px) {
            font-size: 1.05em;
        }
        &:hover {
            font-size: 1.1em;
            padding: 15px 40px;
        }
    }

    > .fa-circle-play {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: ${colors.secondary};
        background-color: ${colors.primary};
        font-size: 2.5cm;
        border-radius: 50%;
        cursor: pointer;
        @media screen and (min-width: 768px) {
            font-size: 3cm;
        }
        &:hover {
            font-size: 4cm;
        }
    }
`

export const LoaderDiv = styled.div`
    position: absolute;
    top: 43%;
    left: 50%;
    width: 55px;
    height: 55px;
    border: 6px solid ${colors.secondary};
    border-top: 6px solid ${colors.primary};
    border-radius: 50%;
    animation: rotate 1s linear infinite;

    @keyframes rotate {
        0% {
            transform: rotate(0deg);
        }
        50% {
            transform: rotate(190deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
`

export const SearchPopupDiv = styled.div`
    flex-direction: column;
    position: absolute;
    left: 0;
    right: 0;
    top: 50px;
    z-index: 10;
    background-color: rgba(10, 10, 10, 1);
    width: 100%;
    max-height: 90.5vh;
    border-radius: 10px;
    > .resultsMovie {
        display: flex;
        justify-content: start;
        align-items: center;
        flex: 1 1 auto;
        min-height: 0;
        padding: 10px 20px;
        gap: 10px;
        border-bottom: 1px solid rgba(250, 250, 250, 0.1);
        cursor: pointer;

        &:hover {
            background-color: rgba(212, 212, 212, 0.1);
        }

        img {
            width: 7vh;
            height: 9vh;
            border-radius: 6px;
        }
        div {
            align-self: flex-start;
        }
        h2,
        p {
            margin: 0;
        }
        h2 {
            font-size: 1.05em;
        }
        p {
            font-size: 0.8em;
        }
    }

    > button {
        align-self: center;
        flex: 1 1 auto;
        font-size: 0.87em;
        color: ${colors.textColor};
        background: none;
        border: 1px solid ${colors.textColor};
        border-radius: 30px;
        padding: 8px 35px;
        margin: 20px 0;
        cursor: pointer;

        &:hover {
            color: ${colors.primary};
        }
    }
`
